
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function ($, _c, undefined) {
	'use strict';

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.

	var Sage = {

		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				$('.btn').each(function(){
					$(this).html(function(i, html){
						return "<span>"+ html +"</span>";
					});
				});

				if ($('.reveal').length > 0){
			        $('.reveal').each(function(e){
			            var reveal = $(this);
			            var waypoint_reveal = new Waypoint({
			                element: reveal[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
			                        reveal.addClass('on');
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

			    function mHeight()
				{
					var height = $('.mheight-boxes-section .match-height').first().height();
                    $('.mheight-boxes-section .match-height.last-section-big').height(height);
				}

				if ($('.mheight-boxes-section')) {
                    mHeight();
				}
				$(window).on('resize', function () {
                    if ($('.mheight-boxes-section')) {
                        mHeight();
                    }
                })

				$('.hamburger').on('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					if ($(this).hasClass('is-active')) {
						$('.main-nav').css('transform', 'translate3d(0, 0, 0)');
						$('.main-nav').addClass('open');
					} else {
						$('.main-nav').css('transform', 'translate3d(100%, 0, 0)');
						$('.main-nav').removeClass('open');
					}
				});

				$('.page-template-template-missioncritical').on('click', '#navigation .menu-heading', function(){
					if ($(this).parent().hasClass('open')) {
                        $(this).parent().removeClass('open');
					} else {
                        $(this).parent().addClass('open');
					}
				});

				$(window).on('scroll', function(){
					var header = $(window).scrollTop();
					if (header > 0){
						$('header').addClass('fixed');
					} else {
						$('header').removeClass('fixed');
					}
				});

				$('.main-nav').on('click', function (event){
					event.stopPropagation();
				});

				$('.hidden-form-button').on('click', function () {
					$('#scroll-toform').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('#scroll-toform').offset().top - 200
                    }, 300);
                    return false;
                });

				$('.scrollto').on('click', function (event){
					event.preventDefault();
					var section = $(this).attr('href');
					$('html, body').animate({
			            scrollTop: $(section).offset().top - 80
			        }, 1000);
				});

			    if ($('.lightbox').length > 0){
					$('.play-btn').on('click', function (event){
						event.preventDefault();
						var video = $(this).attr('href');
						var overlay = $(this).data('overlay');
						$('.lightbox').hide();
						$('#overlay-'+overlay).show();
						$(video).fadeIn(400);
					});

					$('.lightbox .close').on('click', function (event){
						event.preventDefault();
						var vid = $(this).data('video');
						var video = $('#tab-video-'+vid+' iframe[src*="vimeo"]');
						$('.page-overlay').hide();
						$('.lightbox').hide();
						if ( video.length > 0 ){
							var src = video.attr('src');
							video.attr('src', '');
							video.attr('src', src);
						}
					});

					$('.page-overlay').on('click', function (event){
						event.preventDefault();
						var overlay = $(this).data('overlay');
						var video = $('#tab-video-'+overlay+' iframe[src*="vimeo"]');
						$('.page-overlay').hide();
						$('.lightbox').hide();
						if ( video.length > 0 ){
							var src = video.attr('src');
							video.attr('src', '');
							video.attr('src', src);
						}
					});
				}

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired

        $('a.play-btn').on('click', function(e) {
          e.preventDefault();

          $(this).parents('.video-wrapper').find('video').get(0).play();
          $(this).remove();
        });
				
				$('.js-play').on('click', function(e) {
          e.preventDefault();
					
					if($(this).hasClass('pause')){
						$(this).parents('.video-wrapper').find('video').get(0).pause();
						$(this).removeClass('pause');
					} else {
						$(this).parents('.video-wrapper').find('video').get(0).play();
						$(this).addClass('pause');
					}
          
        });
				
				
			}
		},

		// home page
		'page_template_template_home': {
			init: function() {
				// JavaScript to be fired on all pages

				$(window).on('load', function (){
					$('.scroll').addClass('on');
				});

				// count numbers
				var options = {
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
				};

			    // stats
				if ($('#stats').length > 0){
			        $('#stats').each(function(e){
			            var stats_box = $(this);
			            var waypoint_stats_box = new Waypoint({
			                element: stats_box[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
			                    	$('.count-number').each(function(){
			                    		var test = new CountUp($(this).get(0), 0, $(this).html(), 0, 2.5, options)
										test.start();
									})
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

			    // career photos
				if ($('#home-careers').length > 0){
					$(window).on('scroll', function(){
						var scrolled = $(window).scrollTop();
						$('#home-careers .photo').css('transform', 'translate3d(0, '+ scrolled * -0.2 +'px, 0)');
					});
				}

			    // people photos
				// if ($('#people').length > 0){
				// 	$(window).on('scroll', function(){
				// 		var scrolled = $(window).scrollTop();
				// 		$('#people .photo').css('transform', 'translate3d(0, '+ scrolled * -0.2 +'px, 0)');
				// 	});
				// }

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// about page
		'page_template_template_about': {
			init: function() {
				// JavaScript to be fired on all pages

				// count numbers
				var options = {
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
				};

			    // stats
				if ($('#stats').length > 0){
			        $('#stats').each(function(e){
			            var stats_box = $(this);
			            var waypoint_stats_box = new Waypoint({
			                element: stats_box[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
                                    $('.count-number').each(function(){
                                        var test = new CountUp($(this).get(0), 0, $(this).html(), 0, 2.5, options)
                                        test.start();
                                    })
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

			    // culture photos
				if ($('#culture').length > 0){
					$(window).on('scroll', function(){
						var scrolled = $(window).scrollTop();
						$('#culture .photo').css('transform', 'translate3d(0, '+ scrolled * -0.2 +'px, 0)');
					});
				}

				// capabilities
				var capabilities_swiper = new Swiper('#capabilities .swiper-container', {
					autoplay: false,
                    slidesPerView: 1,
                    loop: false,
                    speed: 1200,
                    spaceBetween: 0,
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {

                    },
                    on: {
						slideChange: function () {
						    $('.pagination li').removeClass('active');
						    $('#pagi-'+capabilities_swiper.activeIndex).addClass('active');
						},
					}
                });

            	$('.pagination li a').on('click', function (event){
            		var slide = $(this).data('slide');
            		$('.pagination li').removeClass('active');
            		$(this).parent().addClass('active');
            		capabilities_swiper.slideTo(slide);
            	});

            	// logos
				var logos_swiper = new Swiper('#logos .swiper-container', {
					autoplay: true,
                    slidesPerView: 4.75,
                    loop: true,
                    speed: 1200,
                    spaceBetween: 100,
                    loopAdditionalSlides:1,
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {
						1023: {
							slidesPerView: 3.75,
						},
						767: {
							slidesPerView: 2.75,
						},
						580: {
							slidesPerView: 1.75,
						},
                    },
                    on: {
						slideChange: function () {

						},
					}
                });

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// build page
		'page_template_template_projects': {
			init: function() {
				// JavaScript to be fired on all pages

                // tabs
                var win_width = $(window).width() / 2;
                $('.tabs li').each(function(){
                    var left = $(this).offset().left;
                    if (left < win_width){
                        $(this).addClass('left')
                    } else {
                        $(this).addClass('right');
                    }
                });

				// grid
				function grid(){
					var grid_width = $('.link-1-1').width();
					var grid_width_x2 = grid_width * 2;
					var grid_width_x3 = grid_width * 3;
					var grid_width_x4 = grid_width * 4;
					$('.photo-1-1').css({'clip': 'rect(0px, '+grid_width+'px, 350px, 0px)'})
					$('.photo-1-2').css({'clip': 'rect(0px, '+grid_width_x2+'px, 350px, '+grid_width+'px)'})
					$('.photo-1-3').css({'clip': 'rect(0px, '+grid_width_x3+'px, 350px, '+grid_width_x2+'px)'})
					$('.photo-1-4').css({'clip': 'rect(0px, '+grid_width_x4+'px, 350px, '+grid_width_x3+'px)'})
					$('.photo-2-1').css({'clip': 'rect(350px, '+grid_width+'px, 700px, 0px)'})
					$('.photo-2-2').css({'clip': 'rect(350px, '+grid_width_x2+'px, 700px, '+grid_width+'px)'})
					$('.photo-2-3').css({'clip': 'rect(350px, '+grid_width_x3+'px, 700px, '+grid_width_x2+'px)'})
					$('.photo-2-4').css({'clip': 'rect(350px, '+grid_width_x4+'px, 700px, '+grid_width_x3+'px)'})
				}
				grid();

				$(window).on('resize', function(){
					grid();
				});

				$('.link').on('mouseenter', function (event){
					var grid = $(this).data('grid');
					$('.photo').not('.photo-'+grid).addClass('off');
					$('.photo-'+grid).addClass('on');
					$('.link').not('.link-'+grid).addClass('off');
					$('.link-'+grid).addClass('on');
				}).on('mouseleave', function(){
					var grid = $(this).data('grid');
					$('.photo').removeClass('off');
					$('.photo').removeClass('on');
					$('.link').removeClass('off');
					$('.link').removeClass('on');
				});

                // project
                $('#projects .links .link .main li a, #more-projects li a').on('click', function (event){
                    event.preventDefault();
                    var project = $(this).data('project');
                    $('.project').hide();
                    $('#'+project).fadeIn(400);
                    $('html, body').animate({
                        scrollTop: $('.breadcrumbs').offset().top
                    }, 1000);
                    slider();
                });

                $('.project .close').on('click', function (event){
                    event.preventDefault();
                    $('.project').hide();
                });

                $('.project .prev').on('click', function (event){
                    event.preventDefault();
                    var project = $(this).parent().parent().parent().parent().data('number');
                    project = project - 1;
                    if (project > 0) {
                        $('.project').hide();
                        $('#project-'+project).fadeIn(400);
                    }
                    slider();
                });

                $('.project .next').on('click', function (event){
                    event.preventDefault();
                    var max = $('.project').length + 1;
                    console.log(max);
                    var project = $(this).parent().parent().parent().parent().data('number');
                    project = project + 1;
                    console.log(project);
                    if (project < max) {
                        $('.project').hide();
                        $('#project-'+project).fadeIn(400);
                    }
                    slider();
                });

            	// project photos
            	function slider(){
					var photo_swiper = new Swiper('.project .swiper-container', {
						autoplay: true,
	                    slidesPerView: 1,
	                    loop: true,
	                    speed: 1200,
	                    spaceBetween: 0,
	                    loopAdditionalSlides:1,
	                    simulateTouch: false,
	                    queueStartCallbacks: true,
	                    queueEndCallbacks: true,
						pagination: {
							el: '.pagination',
							type: 'bullets',
							clickable: true,
						},
	                    on: {
							slideChange: function () {

							},
						}
	                });
				}
				slider();

				if ($(window).width() < 481){
					$('#catagories .links .link .main > li > a').on('click', function (event){
						event.preventDefault();
						if ($(this).hasClass('open')){
							$(this).next().slideUp(400);
							$(this).removeClass('open');
						} else {
							$(this).next().slideDown(400);
							$(this).addClass('open');
						}
					});
				}

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// projects new page
		'page_template_template_projects_new': {
			init: function() {
				$('.to-top').click(function(){
					$("body,html").animate({
						scrollTop: $("#projects").offset().top+100
					}, 500);

					return false;
				});

				if ($('#projects .categories span').hasClass('activated-category')) {
                    setTimeout(function() {
                        $('#projects .categories span.activated-category').trigger('click');
                    }, 700);
				}

				function showProjects()
				{
					var categories = [];
					var subcategories = [];

					$('.single-project').hide();

					if($('.categories span.active').length){
						$('.categories span.active').each(function(){
							var id = $(this).data('id');
							categories.push(id);

							if(!$('.subcategories span.active[data-parent='+id+']').length)
								//$('.subcategories span.active[data-parent='+id+']').fadeIn(800);
								$('.single-project.cat-'+id).fadeIn(800);
						});

						$('.subcategories span.active').each(function(){
							var id = $(this).data('id');
							subcategories.push(id);

							$('.single-project.cat-'+id).fadeIn(800);
						});

						setCookie('categories', categories);
						setCookie('subcategories', subcategories);
					} else {
						$('.single-project').fadeIn(800);
					}

					if($('.categories span.active.has-childrens').length){
						$('.subfilter').slideDown();
					} else {
						$('.subfilter').slideUp();
					}

					Waypoint.refreshAll();

				}

				$('.subcategories span').hide();
				$('.selectedcategories span').hide();

				$('a.filter-show').click(function(){
					if($(this).hasClass('active')){
						$(this).removeClass('active');
						$('.filter').slideUp();
					} else {
						$(this).addClass('active');
						$('.filter').slideDown();
					}

					return false;
				});

				$('.categories span').click(function(){
					var id = $(this).data('id');

					if($(this).hasClass('active')){
						$(this).removeClass('active');
						$('.subcategories span[data-parent='+id+']').hide().removeClass('active');
						$('.selectedcategories span[data-parent='+id+']').hide();
						$('.selectedcategories span[data-id='+id+']').hide();
					} else {
						$(this).addClass('active');
						$('.subcategories span[data-parent='+id+']').show();
						$('.selectedcategories span[data-id='+id+']').show();
					}
					var dataHref = $(this).attr('data-href');
					if (dataHref) {
                        window.history.pushState({ path: dataHref }, '', dataHref);
                        /*window.location.href = dataHref;

                        window.location.assign(dataHref);

                        window.location.replace(dataHref);*/
					}

					showProjects();
				});

				$('.subcategories span').on('click', function(){
					var id = $(this).data('id');

					if($(this).hasClass('active')){
						$(this).removeClass('active');
						$('.selectedcategories span[data-id='+id+']').hide();
					} else {
						$(this).addClass('active');
						$('.selectedcategories span[data-id='+id+']').show();
					}

					showProjects();
				});

				$('.selectedcategories .parents span').on('click', function(){
					var id = $(this).data('id');

					$(this).hide();
					$('.categories span[data-id='+id+']').removeClass('active');
					$('.subcategories span[data-parent='+id+']').hide().removeClass('active');
					$('.selectedcategories span[data-parent='+id+']').hide();

					showProjects();
				});

				$('.selectedcategories .childrens span').click(function(){
					var id = $(this).data('id');

					$(this).hide();
					$('.subcategories span[data-id='+id+']').removeClass('active');
					$('.selectedcategories span[data-id='+id+']').hide();

					showProjects();
				});

				$('.clear-all').click(function(){
					$('.categories span').removeClass('active');
					$('.subcategories span').hide().removeClass('active');
					$('.selectedcategories span').hide();

					showProjects();

					return false;
				});

				var categories = getCookie('categories');
				var subcategories = getCookie('subcategories');

				if((categories || subcategories) && findGetParameter('back') == 'true'){
					if(categories){
						categories = categories.split(',');
						categories.forEach(function(el){
							$('.categories span[data-id='+el+']').click();
						});
					}

					if(subcategories){
						subcategories = subcategories.split(',');
						subcategories.forEach(function(el){
							$('.subcategories span[data-id='+el+']').click();
						});
					}

					showProjects()
				}

				function setCookie(name,value) {
						var expires = "";
						var date = new Date();
						date.setTime(date.getTime() + (5*24*60*60*1000));
						expires = "; expires=" + date.toUTCString();
						document.cookie = name + "=" + (value || "")  + expires + "; path=/";
				}
				function getCookie(name) {
						var nameEQ = name + "=";
						var ca = document.cookie.split(';');
						for(var i=0;i < ca.length;i++) {
								var c = ca[i];
								while (c.charAt(0)==' ') c = c.substring(1,c.length);
								if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
						}
						return null;
				}
				function findGetParameter(parameterName) {
						var result = null,
								tmp = [];
						location.search
								.substr(1)
								.split("&")
								.forEach(function (item) {
									tmp = item.split("=");
									if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
								});
						return result;
				}
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// why were better page
		'page_template_template_why_were_better': {
			init: function() {
				// JavaScript to be fired on all pages

				$('#infographic .row .circle').each(function(e){
		            var circle = $(this);
		            var waypoint_circle = new Waypoint({
		                element: circle[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        circle.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .line').each(function(e){
		            var line = $(this);
		            var waypoint_line = new Waypoint({
		                element: line[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        line.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row h3').each(function(e){
		            var header = $(this);
		            var waypoint_header = new Waypoint({
		                element: header[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        header.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .content').each(function(e){
		            var content = $(this);
		            var waypoint_content = new Waypoint({
		                element: content[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        content.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .book').each(function(e){
		            var content = $(this);
		            var waypoint_content = new Waypoint({
		                element: content[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        content.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .arrow-icon').each(function(e){
		            var icon = $(this);
		            var waypoint_icon = new Waypoint({
		                element: icon[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        icon.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .company').each(function(e){
		            var company = $(this);
		            var waypoint_company = new Waypoint({
		                element: company[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        company.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .project-list').each(function(e){
		            var list = $(this);
		            var waypoint_list = new Waypoint({
		                element: list[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        list.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });
				$('#infographic .row .design-wrap').each(function(e){
		            var design_line = $(this);
		            var waypoint_design_line = new Waypoint({
		                element: design_line[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        design_line.addClass('on');
		                    }
		                },
		                offset: '77%'
		            });
		        });

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// careers page
		'page_template_template_careers': {
			init: function() {
				// JavaScript to be fired on all pages

				$(window).on('load', function(){
					var options = {
						strings: subtitle_options,
						typeSpeed: 40,
                        loop: true,
					}

					var typed = new Typed(".typed", options);
				});

                if ($('.tabs').length > 0){
                    $('.tabs li a').on('click', function (event){
                        event.preventDefault();
                        var tab = $(this).attr('href');
                        $('.tab-cnt').hide();
                        $(tab).fadeIn(400);
                        $('.tabs li').removeClass('active');
                        $(this).parent().addClass('active');
                    });
                }

            	// logos
				var logos_swiper = new Swiper('#logos .swiper-container', {
					autoplay: {
						delay: 1,
					},
                    slidesPerView: 4.75,
                    loop: true,
                    speed: 4000,
                    loopAdditionalSlides:1,
                    spaceBetween: 100,
                    simulateTouch: false,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {
						767: {
							slidesPerView: 3.75,
						},
						480: {
							slidesPerView: 2.75,
						},
						380: {
							slidesPerView: 1,
						}
                    },
                    on: {
						slideChange: function () {

						},
					}
                });

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// social page
		'page_template_template_social_impact': {
			init: function() {
				// JavaScript to be fired on all pages

            	// quote
				var quote_swiper = new Swiper('#quote-slider .swiper-container', {
					autoplay: true,
                    slidesPerView: 1,
                    loop: true,
                    delay: 2000,
                    speed: 1200,
                    loopAdditionalSlides:1,
                    spaceBetween: 0,
                    pagination: {
                    	el: '.pagination',
    					type: 'bullets',
    					clickable: true,
                    },
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {

                    },
                    on: {
						slideChange: function () {

						},
					}
                });

            	// organization
				var organization_swiper = new Swiper('#organizations .swiper-container', {
					autoplay: {
						delay: 1,
					},
                    slidesPerView: 4.75,
                    loop: true,
                    speed: 4000,
                    loopAdditionalSlides:1,
                    spaceBetween: 100,
                    simulateTouch: false,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {
						767: {
							slidesPerView: 3.75,
						},
						480: {
							slidesPerView: 2.75,
						},
						380: {
							slidesPerView: 1,
						}
                    },
                    on: {
						slideChange: function () {

						},
					}
                });

				// numbers
				var options = {
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
				};

			    // stats
				if ($('#numbers').length > 0){
			        $('#numbers .number .count-number').each(function(e){
			            var stats_box = $(this);
			            var waypoint_stats_box = new Waypoint({
			                element: stats_box[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
									var test = new CountUp(stats_box[0], 0, stats_box.html(), 0, 2.5, options)
									test.start();
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// contact page
		'page_template_template_contact': {
			init: function() {
				// JavaScript to be fired on all pages

				/*$('.us .pin').on('click', function (event){
					event.preventDefault();
					var location = $(this).attr('href');
					$('.location-box').hide();
					$(location).fadeIn(400);
					$('.us .pin').removeClass('active');
					$(this).addClass('active');
					$('html, body').animate({
			            scrollTop: $('#locations').offset().top
			        }, 1000);
			        initialize();
				});*/

				function initialize(){

					/*var styles=[{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#f7f1df"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#d0e3b4"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"geometry","stylers":[{"color":"#fbd3da"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#bde6ab"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffe15f"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#efd151"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"black"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"color":"#cfb2db"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a2daf2"}]}];
					var styledMap = new google.maps.StyledMapType(styles);

					for (var i = 0; i < lat_lng_arr.length; i++){

                        var latlng = new google.maps.LatLng(lat_lng_arr[i]['lat'],lat_lng_arr[i]['lng']);

                        var myOptions =
                            {
                                center: latlng,
                                zoom: 12,
                                mapTypeControlOptions: {
                                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                                },
                                panControl: false,
                                zoomControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                overviewMapControl: false
                            };

                        var map = new google.maps.Map($('#location-'+ (parseInt(i) + 1) +' .map')[0], myOptions);

                        var myMarker = new google.maps.Marker(
                            {
                                position: latlng,
                                icon: window.location.protocol+'//'+window.location.hostname +'/wp-content/themes/arco-murray-theme/dist/images/pin.png',
                                map: map,
                            });

                        map.mapTypes.set('map_style', styledMap);
                        map.setMapTypeId('map_style');
                        myMarker.setMap(map);*/
					//}
				}
				initialize();

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// project page
		'single_project': {
			init: function() {
				// JavaScript to be fired on all pages
				$(window).load(function(){
					$('.info-bg-slider').css('padding-left',$('.top-info-bg').outerWidth()+$('.top-info-bg').offset().left+1)
				});
				$(window).resize(function(){
					$('.info-bg-slider').css('padding-left',$('.top-info-bg').outerWidth()+$('.top-info-bg').offset().left+1)
				}).resize();

				// numbers
				var options = {
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
				};
				if ($('.info-bg-slider').length > 0) {
                    $('.info-bg-slider ').on('click', '.bg', function () {
						var data = $(this).attr('data-href');

						$('.popup img').attr('src', data);
						$('.popup').show();

						//$('#banner .banner').css('background-image', 'url('+data+')');
                        //$("html, body").animate({ scrollTop: 0 }, 800);
                        //$('#banner .banner').css('display', 'none');
                    });

					$('.popup, .popup .close').click(function(){
						$('.popup').hide();

						return false;
					})
				}
			    // stats
				if ($('#stats').length > 0){
			        $('#stats').each(function(e){
			            var stats_box = $(this);
			            var waypoint_stats_box = new Waypoint({
			                element: stats_box[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
                                    $('.count-number').each(function(){
                                        var test = new CountUp($(this).get(0), 0, $(this).html(), 0, 2.5, options)
                                        test.start();
                                    });
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

        // News page
        'page_template_template_news': {
            init: function() {

                function loadNews() {
                    var btn = $('#news .load-btn');
                    var page = btn.attr('data-page');
                    var url = btn.data('url');

                    $.ajax({
                        type: 'GET',
                        url: url,
                        data: {page: page},
                        success: function (data) {
                            if (data !== '' && typeof data != 'undefined') {
                                $('#news .row').append(data);

                                if ($('#news .row .col-xs-4').length < 6){
                                    btn.hide();
                                }
                                else {
                                    btn.attr('data-page', parseInt(page) + 1);
                                }
                            }
                            else {
                                btn.hide();
                            }
                        }
                    })
                }

                $(window).on('load', function () {
                    loadNews();
                });

                $('#news .load-btn').click(function (e) {
                	e.preventDefault();
                    loadNews();
                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },

		'page_template_template_flex': {
			init: function() {
				// quote
				var quote_swiper = new Swiper('.quote-slider .swiper-container', {
					autoplay: false,
                    slidesPerView: 1,
                    loop: true,
                    speed: 1200,
                    loopAdditionalSlides:1,
                    spaceBetween: 0,
                    pagination: {
                    	el: '.pagination',
    					type: 'bullets',
    					clickable: true,
                    },
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    breakpoints: {

                    },
                    on: {
						slideChange: function () {

						},
					}
                });

				if($('.js-top').length) {
					$('.js-top').on('click', function(){
						$('html, body').animate({
							scrollTop: $('header').offset().top
						}, 2000);
					});
				}
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
		},
		'page_template_template_news_update': {
			init: function() {
				$('body').on('click', '#news .categories .cat-link', function (e) {
					e.preventDefault();

					var link = $(this).data('href');

					$('#news .categories .cat-link').removeClass('active');
					$(this).addClass('active');
                    var dataHref = $(this).attr('data-link');
                    console.log(dataHref)
                    if (dataHref) {
                        window.history.pushState({ path: dataHref }, '', dataHref);

                    }

					$('.js-result').load(link + ' .js-result .links', function () {
						//console.log(link + ' loaded into .results');
						if ($('.reveal').length > 0){
							$('.reveal').each(function(e){
								var reveal = $(this);
								var waypoint_reveal = new Waypoint({
									element: reveal[0],
									handler: function(direction) {
										if (direction === 'down'){
											reveal.addClass('on');
										}
									},
									offset: '77%'
								});
							});
						}

					});

				});
			},
			finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
		},

		'page_template_template_flex_2': {
			init: function() {

				$('.organizations .swiper-container').each(function () {
					var swiper_element = $(this);

					// organization
					var organization_swiper = new Swiper(swiper_element[0], {
						autoplay: {
							delay: 1,
						},
						slidesPerView: 4.75,
						loop: true,
						speed: 4000,
						loopAdditionalSlides:1,
						spaceBetween: 100,
						simulateTouch: false,
						queueStartCallbacks: true,
						queueEndCallbacks: true,
						breakpoints: {
							767: {
								slidesPerView: 3.75,
							},
							480: {
								slidesPerView: 2.75,
							},
							380: {
								slidesPerView: 1,
							}
						},
						on: {
							slideChange: function () {

							},
						}
					});
				});


				// quote

				$('.quote-slider .swiper-container').each(function(){
					var swiper_element_quote = $(this);

					var quote_swiper = new Swiper(swiper_element_quote[0], {
						autoplay: true,
						slidesPerView: 1,
						loop: true,
						//delay: 2000,
						 //autoplay: 400,
						speed: 1200,
						loopAdditionalSlides:1,
						spaceBetween: 0,
						pagination: {
							el: '.pagination',
							type: 'bullets',
							clickable: true,
						},
						autoplay: {
							delay : 8000
					  },
						simulateTouch: true,
						queueStartCallbacks: true,
						queueEndCallbacks: true,
						breakpoints: {

						},
						on: {
							slideChange: function () {

							},
						}
					});

				});
				
				jQuery('.audio-control').click(function(){
					if(jQuery(this).parents('.video-wrapper').find('video').prop('muted') ) {		
						jQuery(this).parents('.video-wrapper').find('video').prop('muted', false);
						jQuery(this).removeClass('mute');
						jQuery(this).parents('.video-wrapper').find('video').addClass('video-unmute');
						
					} else {
						jQuery(this).parents('.video-wrapper').find('video').prop('muted', true);
						jQuery(this).addClass('mute');
						jQuery(this).parents('.video-wrapper').find('video').removeClass('video-unmute');
					}
					
					return false;
				});
				
			


			},
			finalize: function() {
					// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
